import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <div className="max-w-7xl mx-auto">
        <ol className="flex items-center gap-2 text-sm flex-wrap">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={index} className="flex items-center gap-2">
                {index > 0 && (
                  <span className="text-foreground-400">/</span>
                )}
                {isLast || !item.href ? (
                  <span className="text-foreground-600">{item.label}</span>
                ) : (
                  <Link
                    to={item.href}
                    className="text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
}